/**
 * Suppress ResizeObserver "loop completed with undelivered notifications" - a benign
 * browser quirk that occurs with virtualized lists (e.g. react-virtuoso) when
 * scroll/layout triggers observations. Must be imported first in index.tsx.
 */
const isResizeObserverError = (msg: unknown): boolean => {
  let s: string;
  if (typeof msg === 'string') {
    s = msg;
  } else if (msg != null && typeof msg === 'object' && 'message' in msg) {
    s = String((msg as { message: unknown }).message ?? '');
  } else {
    s = '';
  }
  return (
    s.includes('ResizeObserver loop completed with undelivered notifications') ||
    s.includes('ResizeObserver loop limit exceeded')
  );
};

const hideOverlay = (): void => {
  const ids = ['webpack-dev-server-client-overlay-div', 'webpack-dev-server-client-overlay'];
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
  });
};

const prevOnError = window.onerror;
window.onerror = function (
  msg: string | Event,
  url?: string,
  lineNo?: number,
  columnNo?: number,
  error?: Error,
): boolean {
  if (isResizeObserverError(msg)) {
    setTimeout(hideOverlay, 0);
    return true;
  }
  if (typeof prevOnError === 'function') {
    return Boolean(prevOnError.call(this, msg, url, lineNo, columnNo, error));
  }
  return false;
};

window.addEventListener(
  'error',
  (e: ErrorEvent) => {
    const msg = e?.message ?? (e?.error instanceof Error ? e.error.message : '');
    if (isResizeObserverError(msg)) {
      e.stopImmediatePropagation();
      hideOverlay();
    }
  },
  { capture: true },
);

export {};
